type OverlayStyle = {
  left: number;
  top: number;
  width: number;
};

type ResolveSelectPanelStyleOptions = {
  optionCount?: number;
  panel?: Element | null;
  variant?: "custom" | "default";
};

const PANEL_GAP = 8;
const PANEL_PADDING = 8;
const PANEL_MAX_HEIGHT = 240;
const CUSTOM_OPTION_HEIGHT = 48;
const DEFAULT_OPTION_HEIGHT = 40;

function resolvePanelHeight(
  panel: Element | null | undefined,
  optionCount: number,
  variant: "custom" | "default"
) {
  const measuredHeight = panel?.getBoundingClientRect().height ?? 0;

  if (measuredHeight > 0) {
    return Math.min(measuredHeight, PANEL_MAX_HEIGHT);
  }

  const optionHeight = variant === "custom" ? CUSTOM_OPTION_HEIGHT : DEFAULT_OPTION_HEIGHT;

  return Math.min(Math.max(optionCount, 1) * optionHeight, PANEL_MAX_HEIGHT);
}

function resolveSelectPanelStyle(
  root: Element | null,
  { optionCount = 1, panel, variant = "default" }: ResolveSelectPanelStyleOptions = {}
): OverlayStyle | null {
  if (!root || typeof window === "undefined") {
    return null;
  }

  const trigger = root.querySelector('[data-slot="select-trigger"]') ?? root;
  const rect = trigger.getBoundingClientRect();
  const width = Math.max(0, Math.min(rect.width, window.innerWidth - PANEL_PADDING * 2));
  const panelHeight = resolvePanelHeight(panel, optionCount, variant);
  const hasSpaceBelow = window.innerHeight - rect.bottom >= panelHeight + PANEL_GAP + PANEL_PADDING;
  const top = hasSpaceBelow
    ? rect.bottom + PANEL_GAP
    : Math.max(PANEL_PADDING, rect.top - PANEL_GAP - panelHeight);
  const left = Math.min(
    Math.max(PANEL_PADDING, rect.left),
    Math.max(PANEL_PADDING, window.innerWidth - width - PANEL_PADDING)
  );

  return {
    left,
    top,
    width,
  };
}

export { resolveSelectPanelStyle };
